(function () {
  var SECTION_SELECTOR = '.oddit-section-recommended-products';
  var sectionState = new Map();

  function fetchRecommendations(section) {
    var productId = section.getAttribute('data-product-id');
    var intent = section.getAttribute('data-recommendations-intent') || 'related';
    var limit = section.getAttribute('data-recommendations-limit') || 6;
    var sectionId = section.id;

    if (!productId || !sectionId) return;

    var url =
      window.Shopify.routes.root +
      'recommendations/products?section_id=' +
      sectionId +
      '&product_id=' +
      productId +
      '&limit=' +
      limit +
      '&intent=' +
      intent;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('#' + CSS.escape(sectionId));
        if (newSection && newSection.innerHTML.trim().length > 0) {
          section.innerHTML = newSection.innerHTML;
          var reveals = section.querySelectorAll('.oddit-reveal');
          for (var i = 0; i < reveals.length; i++) {
            reveals[i].classList.add('is-visible');
          }
          initCarousel(section);
          initAutoplay(section);
        }
      })
      .catch(function (err) {
        console.error('[oddit-section-recommended-products] Fetch error:', err);
      });
  }

  function initCarousel(section) {
    var track = section.querySelector('.oddit-section-recommended-products__grid');
    var prevBtn = section.querySelector('.oddit-section-recommended-products__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-recommended-products__arrow--next');

    if (!track) return;

    var state = {
      track: track,
      prevBtn: prevBtn,
      nextBtn: nextBtn
    };

    function getScrollAmount() {
      var card = track.querySelector('.oddit-section-recommended-products__card');
      if (!card) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap, 10) || 24;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = scrollLeft <= 0;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function scrollPrev() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    }

    function scrollNext() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', scrollPrev);
      nextBtn.addEventListener('click', scrollNext);
    }
    track.addEventListener('scroll', updateArrows, { passive: true });

    updateArrows();

    var ro = new ResizeObserver(function () {
      updateArrows();
    });
    ro.observe(track);

    state.scrollPrev = scrollPrev;
    state.scrollNext = scrollNext;
    state.updateArrows = updateArrows;

    state.destroyCarousel = function () {
      if (prevBtn) prevBtn.removeEventListener('click', scrollPrev);
      if (nextBtn) nextBtn.removeEventListener('click', scrollNext);
      track.removeEventListener('scroll', updateArrows);
      ro.disconnect();
    };

    sectionState.set(section.id || section, state);
  }

  function initAutoplay(section) {
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    if (!autoplay) return;

    var speed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state || !state.track) return;

    var track = state.track;
    var paused = false;
    var intervalId;

    function autoScroll() {
      if (paused) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (Math.round(track.scrollLeft) >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (state.scrollNext) {
        state.scrollNext();
      }
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
    }

    intervalId = setInterval(autoScroll, speed);

    section.addEventListener('mouseenter', pause);
    section.addEventListener('mouseleave', resume);
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', resume);

    var prevDestroy = state.destroyCarousel;
    state.destroyCarousel = function () {
      clearInterval(intervalId);
      section.removeEventListener('mouseenter', pause);
      section.removeEventListener('mouseleave', resume);
      section.removeEventListener('focusin', pause);
      section.removeEventListener('focusout', resume);
      if (prevDestroy) prevDestroy();
    };
  }

  function destroySection(section) {
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state) return;
    if (state.destroyCarousel) state.destroyCarousel();
    sectionState.delete(key);
  }

  function handleAddToCart(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    var quantity = Number(btn.getAttribute('data-quantity')) || 1;
    btn.disabled = true;

    if (window.OdditCartDrawer) {
      window.OdditCartDrawer.addToCart(variantId, quantity)
        .then(function () {
          window.OdditCartDrawer.open();
        })
        .finally(function () {
          btn.disabled = false;
        });
    } else {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (err) {
          console.error('[oddit-section-recommended-products] Add to cart error:', err);
        })
        .finally(function () {
          btn.disabled = false;
        });
    }
  }

  function initSection(section) {
    fetchRecommendations(section);
    section.addEventListener('click', handleAddToCart);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
    initSection(section);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();